<template>
  <div class="flex flex-col gap-1">
    <slot name="items" />
  </div>
</template>

<script setup></script>
